
const getNextSaturday = () => {
  const today = new Date();
  const nextSaturday = new Date(today);
  const dayOfWeek = today.getDay();
  const daysUntilSaturday = (6 - dayOfWeek + 7) % 7 || 7;
  nextSaturday.setDate(today.getDate() + daysUntilSaturday);

  const year = nextSaturday.getFullYear();
  const month = (nextSaturday.getMonth() + 1).toString().padStart(2, "0");
  const day = nextSaturday.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

// Format a local Date as YYYY-MM-DD (the value shape <input type="date"> uses)
const toDateInputValue = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Returns the default Wednesday-to-Tuesday game week (centered on the next
 * Saturday) as YYYY-MM-DD strings for date inputs.
 * @returns {{ from: string, to: string }}
 */
export const getDefaultWeekDates = () => {
  const today = new Date();
  const daysUntilSaturday = (6 - today.getDay() + 7) % 7 || 7;
  const saturday = new Date(today);
  saturday.setDate(today.getDate() + daysUntilSaturday);
  const wednesday = new Date(saturday);
  wednesday.setDate(saturday.getDate() - 3);
  const tuesday = new Date(saturday);
  tuesday.setDate(saturday.getDate() + 3);
  return { from: toDateInputValue(wednesday), to: toDateInputValue(tuesday) };
};

// The Odds API requires ISO8601 with no fractional seconds
// (e.g. 2026-08-21T06:00:00Z) and returns 422 otherwise.
const toOddsApiIso = (date) => date.toISOString().replace(/\.\d{3}Z$/, "Z");

/**
 * Converts YYYY-MM-DD from/to values into the ISO range fetchApiEvents
 * expects: from = local start of day, to = local 23:59:59.
 * Dates are parsed as local days so the range matches what the admin picked
 * regardless of timezone.
 * @returns {{ from: string, to: string }} ISO 8601 date strings
 */
export const toCommenceTimeRange = (fromDate, toDate) => {
  const [fy, fm, fd] = fromDate.split("-").map(Number);
  const [ty, tm, td] = toDate.split("-").map(Number);
  const from = new Date(fy, fm - 1, fd, 0, 0, 0);
  const to = new Date(ty, tm - 1, td, 23, 59, 59);
  return {
    from: toOddsApiIso(from),
    to: toOddsApiIso(to),
  };
};

/**
 * Returns the default Wednesday-to-Tuesday "game week" window as ISO strings.
 * @returns {{ from: string, to: string }} ISO 8601 date strings
 */
export const getWeekDateRange = () => {
  const { from, to } = getDefaultWeekDates();
  return toCommenceTimeRange(from, to);
};

export default getNextSaturday;
